import { Flex } from '@chakra-ui/react'

import { Loader } from './Loader'

export const FullScreenLoader = () => {
  return (
    <Flex height="100vh" width="100%" justify="center" align="center">
      <Loader />
    </Flex>
  )
}
